import { createVNode as l, mergeProps as s } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RefreshFilled.js";
import f from "../components/PfIcon.js";
const e = (r, t) => {
  const o = {
    ...r,
    ...t.attrs
  };
  return l(f, s(o, {
    icon: i
  }), null);
};
e.displayName = "RefreshFilled";
e.inheritAttrs = !1;
export {
  e as default
};
